"use strict";
/**
 * The giftwrap module provides access to the Giftwrap specific calls on the EVA back-end
 * @preferred
 */
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
/**
 * Provides access to a Rituals specific functions in EVA
 */
var Giftwrap;
(function (Giftwrap) {
    function getGiftWrappingOptionsForOrder(requestData) {
        var service = new service_1.EVAService("GetGiftWrappingOptionsForOrder");
        return service.call(requestData);
    }
    Giftwrap.getGiftWrappingOptionsForOrder = getGiftWrappingOptionsForOrder;
    function setGiftWrappingOptionsOnOrder(requestData) {
        var service = new service_1.EVAService("SetGiftWrappingOptionsOnOrder");
        return service.call(requestData);
    }
    Giftwrap.setGiftWrappingOptionsOnOrder = setGiftWrappingOptionsOnOrder;
})(Giftwrap = exports.Giftwrap || (exports.Giftwrap = {}));
